<template>
  <div class="topbar">
    <!-- Logged in -->
    <template v-if="auth.isLoggedIn">

    <nav id="appNav" class="navbar-custom">
      <ul class="list-inline float-right mb-0">
        <!--<li class="list-inline-item dropdown notification-list">
          <a class="nav-link dropdown-toggle arrow-none waves-effect" data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
            <i class="ion-ios7-bell noti-icon"></i>
            <span class="badge badge-success noti-icon-badge">1</span>
          </a>

          <div class="dropdown-menu dropdown-menu-right dropdown-arrow dropdown-menu-lg">

            <div class="dropdown-item noti-title">
              <h5><span class="badge badge-danger float-right">1</span>Notificaciones</h5>
            </div>


            <a href="javascript:void(0);" class="dropdown-item notify-item">
              <div class="notify-icon bg-primary"><i class="mdi mdi-cart-outline"></i></div>
              <p class="notify-details"><b>Notificacion de prueba</b><small class="text-muted">Esto es una prueba.</small></p>
            </a>


            <a href="javascript:void(0);" class="dropdown-item notify-item">
              Ver Todas
            </a>

          </div>
        </li>-->
        <li class="list-inline-item dropdown notification-list">
          <a class="nav-link dropdown-toggle arrow-none waves-effect nav-user" data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
            <img src="../assets/img/default-avatar.png" alt="user" class="rounded-circle">
          </a>
          <div class="dropdown-menu dropdown-menu-right profile-dropdown ">
            <!--<a class="dropdown-item" href="#"><i class="mdi mdi-account-circle m-r-5 text-muted"></i> Perfil</a>-->
            <!--<a class="dropdown-item" href="#"><i class="mdi mdi-settings m-r-5 text-muted"></i> Configuración</a>-->
            <a class="dropdown-item" href="#" @click="logout()"><i class="mdi mdi-logout m-r-5 text-muted"></i> Salir</a>
          </div>
        </li>
      </ul>

      <ul class="list-inline menu-left mb-0">
        <li class="list-inline-item">
          <button type="button" class="button-menu-mobile open-left waves-effect" @click="clickInMobileMenu()">
            <i class="ion-navicon"></i>
          </button>
        </li>
        <li class="hide-phone list-inline-item app-search">
          <h3 class="page-title">Escritorio</h3>
        </li>
      </ul>
    </nav>
    </template>

    <!-- Not logged in -->
    <template v-else>

    </template>
  </div>
</template>


<script>
  import Auth from '../auth'

  export default {
    name: 'app-nav',
    data () {
      return {
        auth: this.$store.state.auth
      }
    },
    computed: {
      mobileMenuIsActive: function () {
        return this.$store.getters.getMobileMenuStatus
      }
    },
    watch: {
      mobileMenuIsActive: function (value) {
        if(this.mobileMenuIsActive) {
          $('body').addClass('fixed-left-void')
          $('#wrapper').addClass('enlarged')
        } else {
          $('body').removeClass('fixed-left-void')
          $('#wrapper').removeClass('enlarged')
        }
      }
    },
    methods: {
      logout () {
        Auth.logout()
      },
      clickInMobileMenu () {
        this.$store.dispatch('showMobileMenu', { show: !this.mobileMenuIsActive })
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppNav.vue